import React from 'react'
import Style from './buttonbar.module.scss'
import { Button } from 'antd'
interface Props {
  title?: string
  headeBox?: React.ReactNode // 特殊
  headeLeftBox?: React.ReactNode // 左侧按钮
  onRefresh?: () => void // 刷新
}
// 按钮操作栏
const Buttonbar: React.FC<Props> = (props) => {
  const { title, headeBox, headeLeftBox, onRefresh } = props
  return (
    <div className={Style.container}>
      <div className={Style.containerleft}>
        操作：
        {headeBox}
        <Button type="link" size="small" onClick={onRefresh}>
          刷新
        </Button>
        {headeLeftBox}
      </div>
      <div className={Style.containercenter}>{title}</div>
      <div className={Style.containerright}>{props.children}</div>
    </div>
  )
}

export default Buttonbar
import React from 'react'
import Style from './buttonbar.module.scss'
import { Button } from 'antd'
interface Props {
  title?: string
  headeBox?: React.ReactNode // 特殊
  headeLeftBox?: React.ReactNode // 左侧按钮
  onRefresh?: () => void // 刷新
}
// 按钮操作栏
const Buttonbar: React.FC<Props> = (props) => {
  const { title, headeBox, headeLeftBox, onRefresh } = props
  return (
    <div className={Style.container}>
      <div className={Style.containerleft}>
        操作：
        {headeBox}
        <Button type="link" size="small" onClick={onRefresh}>
          刷新
        </Button>
        {headeLeftBox}
      </div>
      <div className={Style.containercenter}>{title}</div>
      <div className={Style.containerright}>{props.children}</div>
    </div>
  )
}

export default Buttonbar
